// The sign-up terms line (FR-009; user answer OQ-4): "By creating an account you agree to the Terms
// of use and the Privacy policy", each a link, no checkbox. Hidden until the public config has both
// https addresses (config/validate.ts), which Akaiva provides.
import { useMemo } from "react";
import { Linking, Platform } from "react-native";

import { ConfigError, readPublicConfig } from "@/config";
import { Text } from "@/ui/Text";

import { AUTH_COPY } from "../copy";

export type LegalLinks = { termsUrl: string; privacyUrl: string };

/** Both addresses from the public config, or null (the line stays hidden). */
export function useLegalLinks(): LegalLinks | null {
  return useMemo(() => {
    try {
      const { termsUrl, privacyUrl } = readPublicConfig();
      return termsUrl && privacyUrl ? { termsUrl, privacyUrl } : null;
    } catch (error) {
      if (error instanceof ConfigError) return null;
      throw error;
    }
  }, []);
}

function DocumentLink({ url, children }: { url: string; children: string }) {
  // Web: a real anchor in a new tab with no referrer or opener; Android: the system browser.
  const target =
    Platform.OS === "web"
      ? ({
          href: url,
          hrefAttrs: { target: "_blank", rel: "noopener noreferrer" },
        } as object)
      : { onPress: () => void Linking.openURL(url) };
  return (
    <Text tone="primary" weight="semiBold" size="sm" role="link" {...target}>
      {children}
    </Text>
  );
}

export function LegalLine({ links }: { links: LegalLinks }) {
  const c = AUTH_COPY.signUp;
  return (
    <Text tone="muted" size="sm" testID="sign-up-legal">
      {c.termsLead}
      <DocumentLink url={links.termsUrl}>{c.terms}</DocumentLink>
      {c.and}
      <DocumentLink url={links.privacyUrl}>{c.privacy}</DocumentLink>
    </Text>
  );
}
